import React from "react"

export default function AuthorContent({ authorId }) {

  let authorName = ''
  let description = ''

  if (authorId === 1) {
    authorName = 'サリ'
    description = 'Laxus エディター。ファッションは大好きだけど、冒険は苦手。女性らしい可愛らしさは忘れたくない。フィービー時代のCELINE（セリーヌ）を愛してやまないが、最近はChloe（クロエ）が気になる。好きな食べ物はフライドポテト。'
  } else {
    authorName = 'キョウコ'
    description = 'Laxus ファッションライター。ファッションをウォッチして20数年。ひとクセあるモードなアイテムが好み。BOTTEGA VENETA（ボッテガ・ヴェネタ）やLOEWE（ロエベ）などの旬ブランドはもちろん大好き。でも、LOUIS VUITTON（ルイ・ヴィトン）の定番が恋しくなる日も。好きな食べ物は赤身肉。'
  }

  return (
    <section id="author-content">
    <div className="text-two-cloumn">
      <h2>筆者情報</h2>
      <div className="author-description">
        <p className="author">{authorName}</p>
        <p>{description}</p>
      </div>
    </div>
  </section>
  )
}




